import { render, staticRenderFns } from "./editCubeMsgShop.vue?vue&type=template&id=07d17b1a&scoped=true&"
import script from "./editCubeMsgShop.vue?vue&type=script&lang=js&"
export * from "./editCubeMsgShop.vue?vue&type=script&lang=js&"
import style0 from "./editCubeMsgShop.vue?vue&type=style&index=0&id=07d17b1a&prod&lang=scss&"
import style1 from "./editCubeMsgShop.vue?vue&type=style&index=1&id=07d17b1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d17b1a",
  null
  
)

export default component.exports